import {
  updataDispatchRefunds,
  getDispatchRefunds,
  gatDispatcherInfo,
  updateDispatch,
  updateDispatchComment,
  editDispatch,
  newWriterSettlement,
  dispatcherSearch,
  getMyWriterSettlement,
  worktop,
  setUrgentStatus, 
  worktopTaskNeededDispatch,
  worktopDispatchNeededComment,
  worktopDispatchNeededSettlement,
  worktopSettlementNeededRecall,
  worktopTenDayTask,
  worktopNextDayTask,
  listWriterPendingDispatches,
  batchCompleteDispatch
  
} from '@/api/dispatcher'

const state = {
}

const mutations = {
}

const actions = {

  // 在 actions 里加：
  listWriterPendingDispatches({ commit }, params) {
    return new Promise((resolve, reject) => {
      listWriterPendingDispatches(params).then(resolve).catch(reject)
    })
  },
  batchCompleteDispatch({ commit }, data) {
    return new Promise((resolve, reject) => {
      batchCompleteDispatch(data).then(resolve).catch(reject)
    })
  },
  worktopTaskNeededDispatch({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopTaskNeededDispatch(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktopDispatchNeededComment({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopDispatchNeededComment(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktopDispatchNeededSettlement({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopDispatchNeededSettlement(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktopSettlementNeededRecall({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopSettlementNeededRecall(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktopTenDayTask({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopTenDayTask(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktopNextDayTask({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktopNextDayTask(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setUrgentStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      setUrgentStatus(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  worktop({ commit }, param) {
    return new Promise((resolve, reject) => {
      worktop(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmywritersettlement({ commit }, param) {
    return new Promise((resolve, reject) => {
      getMyWriterSettlement(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  dispatchersearch({ commit }, param) {
    return new Promise((resolve, reject) => {
      dispatcherSearch(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newwritersettlement({ commit }, param) {
    return new Promise((resolve, reject) => {
      newWriterSettlement(param).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatadispatchrefunds({ commit }, data) {
    return new Promise((resolve, reject) => {
      updataDispatchRefunds(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getdispatchrefunds({ commit }, data) {
    return new Promise((resolve, reject) => {
      getDispatchRefunds(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatedispatchcomment({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateDispatchComment(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editdispatch({ commit }, data) {
    return new Promise((resolve, reject) => {
      editDispatch(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatedispatch({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateDispatch(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  gatdispatcherinfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      gatDispatcherInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
